import { useEffect, useState } from 'react';
import api from '../services/api';

const TEMPOS_SUGERIDOS = [
  'Present Simple', 'Past Simple', 'Past Participle',
  'Present Continuous', 'Future Simple', 'Present Perfect',
  'Past Continuous', 'Conditional',
];

const S = {
  page: { minHeight: '100vh', background: '#f4f6f9', fontFamily: 'Poppins,sans-serif', padding: '24px 20px' },
  inner: { maxWidth: 1100, margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', borderRadius: 14, padding: '16px 24px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 24 },
  title: { fontSize: '1.3rem', fontWeight: 800, color: '#1a2a4a', margin: 0 },
  btn: (color) => ({ background: color, color: '#fff', border: 'none', borderRadius: 10, padding: '9px 20px', cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem', fontFamily: 'Poppins,sans-serif' }),
  btnSm: (color) => ({ background: color, color: '#fff', border: 'none', borderRadius: 8, padding: '5px 12px', cursor: 'pointer', fontSize: '0.8rem', fontFamily: 'Poppins,sans-serif' }),
  card: { background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 16, overflow: 'hidden' },
  cardHead: (tipo) => ({ background: tipo === 'regular' ? 'linear-gradient(135deg,#2ecc71,#27ae60)' : 'linear-gradient(135deg,#e74c3c,#c0392b)', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }),
  cardVerbo: { color: '#fff', fontWeight: 800, fontSize: '1.15rem', margin: 0 },
  cardTrad: { color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem', margin: 0 },
  cardBody: { padding: '16px 20px' },
  input: { width: '100%', padding: '9px 14px', borderRadius: 8, border: '1px solid #e0e4ea', fontSize: '0.9rem', fontFamily: 'Poppins,sans-serif', marginBottom: 10, boxSizing: 'border-box' },
  select: { padding: '9px 14px', borderRadius: 8, border: '1px solid #e0e4ea', fontSize: '0.9rem', fontFamily: 'Poppins,sans-serif', marginBottom: 10 },
  row: { display: 'flex', gap: 10, alignItems: 'flex-start', flexWrap: 'wrap' },
  conjRow: { background: '#f8fafc', borderRadius: 8, padding: '10px 14px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 },
  tempoBadge: { background: '#dbeafe', color: '#1e40af', borderRadius: 8, padding: '2px 10px', fontSize: '0.75rem', fontWeight: 700, whiteSpace: 'nowrap' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal: { background: '#fff', borderRadius: 16, padding: '28px 24px', maxWidth: 540, width: '100%', maxHeight: '90vh', overflowY: 'auto' },
};

function ModalVerbo({ onClose, onSaved, editVerbo }) {
  const [verbo, setVerbo] = useState(editVerbo?.verbo || '');
  const [traducao, setTraducao] = useState(editVerbo?.traducao || '');
  const [tipo, setTipo] = useState(editVerbo?.tipo || 'regular');
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!verbo.trim() || !traducao.trim()) return alert('Preencha verbo e tradução.');
    setSaving(true);
    try {
      if (editVerbo) {
        await api.put(`/verbos/admin/verbos/${editVerbo.id}`, { verbo, traducao, tipo });
      } else {
        await api.post('/verbos/admin/verbos', { verbo, traducao, tipo });
      }
      onSaved();
    } catch { alert('Erro ao salvar.'); }
    setSaving(false);
  }

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <h3 style={{ margin: '0 0 20px', color: '#1a2a4a' }}>{editVerbo ? 'Editar Verbo' : 'Novo Verbo'}</h3>
        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Verbo em inglês *</label>
        <input style={S.input} value={verbo} onChange={e => setVerbo(e.target.value)} placeholder="Ex: walk" />
        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Tradução *</label>
        <input style={S.input} value={traducao} onChange={e => setTraducao(e.target.value)} placeholder="Ex: caminhar, andar" />
        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Tipo</label>
        <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
          {['regular', 'irregular'].map(t => (
            <button key={t} onClick={() => setTipo(t)}
              style={{ ...S.btn(tipo === t ? (t === 'regular' ? '#2ecc71' : '#e74c3c') : '#e0e4ea'), color: tipo === t ? '#fff' : '#666' }}>
              {t === 'regular' ? 'Regular' : 'Irregular'}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={S.btn('#1e90ff')} onClick={save} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
          <button style={S.btn('#aaa')} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function ModalConjugacao({ verboId, onClose, onSaved, editConj }) {
  const [tempo, setTempo] = useState(editConj?.tempo || '');
  const [conjugacao, setConjugacao] = useState(editConj?.conjugacao || '');
  const [frase, setFrase] = useState(editConj?.frase_exemplo || '');
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!tempo.trim() || !conjugacao.trim()) return alert('Preencha tempo e conjugação.');
    setSaving(true);
    try {
      if (editConj) {
        await api.put(`/verbos/admin/conjugacoes/${editConj.id}`, { tempo, conjugacao, frase_exemplo: frase });
      } else {
        await api.post('/verbos/admin/conjugacoes', { verbo_id: verboId, tempo, conjugacao, frase_exemplo: frase });
      }
      onSaved();
    } catch { alert('Erro ao salvar.'); }
    setSaving(false);
  }

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <h3 style={{ margin: '0 0 20px', color: '#1a2a4a' }}>{editConj ? 'Editar Conjugação' : 'Nova Conjugação'}</h3>

        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Tempo verbal *</label>
        <input list="tempos-list" style={S.input} value={tempo} onChange={e => setTempo(e.target.value)} placeholder="Ex: Past Simple" />
        <datalist id="tempos-list">
          {TEMPOS_SUGERIDOS.map(t => <option key={t} value={t} />)}
        </datalist>

        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Conjugação / Forma *</label>
        <input style={S.input} value={conjugacao} onChange={e => setConjugacao(e.target.value)} placeholder="Ex: walked / I walk every day" />

        <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#555' }}>Frase de exemplo</label>
        <input style={S.input} value={frase} onChange={e => setFrase(e.target.value)} placeholder="Ex: She walked to the park yesterday." />

        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          <button style={S.btn('#1e90ff')} onClick={save} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
          <button style={S.btn('#aaa')} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminVerbos() {
  const [verbos, setVerbos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('all');
  const [busca, setBusca] = useState('');
  const [modalVerbo, setModalVerbo] = useState(false);
  const [editVerbo, setEditVerbo] = useState(null);
  const [modalConj, setModalConj] = useState(null); // { verboId, editConj? }
  const [expandido, setExpandido] = useState(null);

  async function carregar() {
    setLoading(true);
    try {
      const r = await api.get('/verbos');
      setVerbos(r.data);
    } catch { alert('Erro ao carregar verbos.'); }
    setLoading(false);
  }

  useEffect(() => { carregar(); }, []);

  async function excluirVerbo(id) {
    if (!window.confirm('Excluir este verbo e todas as suas conjugações?')) return;
    await api.delete(`/verbos/admin/verbos/${id}`);
    carregar();
  }

  async function excluirConj(id) {
    if (!window.confirm('Excluir esta conjugação?')) return;
    await api.delete(`/verbos/admin/conjugacoes/${id}`);
    carregar();
  }

  const filtrados = verbos.filter(v =>
    (filtro === 'all' || v.tipo === filtro) &&
    (v.verbo.toLowerCase().includes(busca.toLowerCase()) || v.traducao.toLowerCase().includes(busca.toLowerCase()))
  );

  return (
    <div style={S.page}>
      <div style={S.inner}>
        <div style={S.header}>
          <h1 style={S.title}>📚 Gerenciar Verbos</h1>
          <button style={S.btn('#1e90ff')} onClick={() => { setEditVerbo(null); setModalVerbo(true); }}>
            + Novo Verbo
          </button>
        </div>

        <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap', alignItems: 'center' }}>
          {[['all','Todos'],['regular','Regulares'],['irregular','Irregulares']].map(([k,l]) => (
            <button key={k} onClick={() => setFiltro(k)}
              style={{ padding: '7px 20px', borderRadius: 30, border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.85rem', background: filtro === k ? '#1e90ff' : '#e0e4ea', color: filtro === k ? '#fff' : '#555' }}>
              {l}
            </button>
          ))}
          <input placeholder="🔍 Buscar..." value={busca} onChange={e => setBusca(e.target.value)}
            style={{ padding: '8px 16px', borderRadius: 30, border: '1px solid #e0e4ea', fontSize: '0.88rem', fontFamily: 'Poppins,sans-serif', minWidth: 200 }} />
        </div>

        {loading ? <p style={{ textAlign: 'center', color: '#888' }}>Carregando...</p> : null}

        {filtrados.map(v => (
          <div key={v.id} style={S.card}>
            <div style={S.cardHead(v.tipo)}>
              <div onClick={() => setExpandido(expandido === v.id ? null : v.id)} style={{ cursor: 'pointer', flex: 1 }}>
                <p style={S.cardVerbo}>{v.verbo} <span style={{ fontWeight: 400, fontSize: '0.85rem', opacity: 0.8 }}>— {v.traducao}</span></p>
                <p style={S.cardTrad}>{v.tipo === 'regular' ? 'Regular' : 'Irregular'} · {v.conjugacoes.length} conjugação(ões)</p>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={S.btnSm('rgba(255,255,255,0.3)')} onClick={() => { setEditVerbo(v); setModalVerbo(true); }}>✏️ Editar</button>
                <button style={S.btnSm('rgba(220,50,50,0.5)')} onClick={() => excluirVerbo(v.id)}>🗑️ Excluir</button>
              </div>
            </div>

            {expandido === v.id && (
              <div style={S.cardBody}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <strong style={{ color: '#1a2a4a', fontSize: '0.92rem' }}>Conjugações / Tempos Verbais</strong>
                  <button style={S.btnSm('#2ecc71')} onClick={() => setModalConj({ verboId: v.id })}>+ Adicionar</button>
                </div>

                {v.conjugacoes.length === 0 && <p style={{ color: '#aaa', fontSize: '0.85rem' }}>Nenhuma conjugação cadastrada.</p>}

                {v.conjugacoes.map(c => (
                  <div key={c.id} style={S.conjRow}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4, flexWrap: 'wrap' }}>
                        <span style={S.tempoBadge}>{c.tempo}</span>
                        <span style={{ fontWeight: 700, color: '#1a2a4a', fontSize: '0.9rem' }}>{c.conjugacao}</span>
                      </div>
                      {c.frase_exemplo && <p style={{ color: '#888', fontSize: '0.82rem', fontStyle: 'italic', margin: 0 }}>"{c.frase_exemplo}"</p>}
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      <button style={S.btnSm('#1e90ff')} onClick={() => setModalConj({ verboId: v.id, editConj: c })}>✏️</button>
                      <button style={S.btnSm('#e74c3c')} onClick={() => excluirConj(c.id)}>🗑️</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        {!loading && filtrados.length === 0 && <p style={{ textAlign: 'center', color: '#aaa', marginTop: 40 }}>Nenhum verbo encontrado.</p>}
      </div>

      {modalVerbo && (
        <ModalVerbo
          editVerbo={editVerbo}
          onClose={() => { setModalVerbo(false); setEditVerbo(null); }}
          onSaved={() => { setModalVerbo(false); setEditVerbo(null); carregar(); }}
        />
      )}

      {modalConj && (
        <ModalConjugacao
          verboId={modalConj.verboId}
          editConj={modalConj.editConj}
          onClose={() => setModalConj(null)}
          onSaved={() => { setModalConj(null); carregar(); }}
        />
      )}
    </div>
  );
}
